module.exports = __webpack_public_path__ + "img/9791160350319.218f7617.jpg";